<template>
  <div v-if="!isHidden">
    <div class="hire-body">
      <div>
        <img class="logobody" src="../../public/novologolaranja.svg" />
        <div>
          <h3>Seu plano ideal de internet é:</h3>
          <h1 v-if="yourPlan" class="pd">{{ yourPlan }}</h1>
          <h1 v-else class="pd">RES ULTRA 200 MEGA</h1>
          <h3>Seu plano ideal de telefonia é:</h3>
          <h1 v-if="yourPhone" class="mg">{{ yourPhone }}</h1>
          <h1 v-else class="pd">VOCÊ Fone Local Fixo Ilimitado</h1>
        </div>
        <div class="btn-wrapper">
          <router-link to="/Channel" class="btn btn-hire">CONTRATAR</router-link>
          <router-link @click="cleanCounter()" to="/Home" class="btn btn-redo">
            <img src="../../public/rmk.png" />Refazer teste
          </router-link>
        </div>
        <p>*Verifique a disponibilidade em seu endereço.</p>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HirePlan",
  props: ["range"],
  data() {
    return {
      yourPlan: "",
      yourPhone: "",
      isHidden: false
    };
  },
  methods: {
    cleanCounter() {
      this.$store.commit("CLEAN_PLANS", 0);
    },
    hideElement() {
      this.isHidden = true;
    }
  },
  created() {
    const result =
      this.$store.state.multiplan +
      this.$store.state.multiplantwo * this.$store.state.plan;

    this.yourPhone = this.$store.state.plantwo;

    if (
      result >= this.range[0].min_poits &&
      result <= this.range[0].max_points
    ) {
      this.yourPlan = "200 MEGA";
    } else if (
      result >= this.range[1].min_poits &&
      result <= this.range[1].max_points
    ) {
      this.yourPlan = "300 MEGA";
    } else if (
      result >= this.range[2].min_poits &&
      result <= this.range[2].max_points
    ) {
      this.yourPlan = "400 MEGA";
    } else if (
      result >= this.range[3].min_poits &&
      result <= this.range[3].max_points
    ) {
      this.yourPlan = "500 MEGA";
    } else if (
      result >= this.range[4].min_poits &&
      result <= this.range[4].max_points
    ) {
      this.yourPlan = "750 MEGA";
    } else if (
      result >= this.range[5].min_poits &&
      result <= this.range[5].max_points
    ) {
      this.yourPlan = "ULTRA 1000 MEGA";
    } else {
      this.yourPlan = "ULTRA 200 MEGA";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/style";

a img {
  width: 28px;
  height: 26px;
  position: absolute;
  top: 29%;
  left: 8%;
}

.logobody {
  position: absolute;
  right: 2em;
  top: 1em;
  width: 120px;
  height: 45px;
}

.pd {
  margin-bottom: 60px;
}

.mg {
  margin-bottom: 90px;
}

.hire-body {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 900px;
  background: $white 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 20px #4605894d;
  border-radius: 48px;
  padding: 116px 90px 63px 90px;
  z-index: 2;
}

.btn-wrapper {
  display: flex;
  justify-content: space-between;
}

.btn {
  width: 239px;
  height: 62px;
  box-shadow: 0px 20px 20px #4605894d;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
  display: block;
  line-height: 4em;
}

.btn:hover {
  box-shadow: 0px 10px 10px #4605894d;
}

.btn-redo {
  background: $white 0% 0% no-repeat padding-box;
  color: $purple;
  position: relative;
}

.btn-hire {
  background: $purple 0% 0% no-repeat padding-box;
  margin-bottom: 40px;
}

h1 {
  text-align: left;
  text-transform: uppercase;
  color: $light-orange;
  font-size: 44px;
  font-weight: bold;
}

h3 {
  text-align: left;
  text-transform: uppercase;
  color: $light-orange;
  font-size: 21px;
  margin-bottom: 10px;
}

p {
  text-align: left;
  font-size: 14px;
  color: $purple;
  font-weight: 600;
}

@media only screen and (max-width: 600px) {
  .hire-body {
    width: 20em;
    height: 28em;
    top: 50%;
    left: 50%;
    padding: 3em;
    z-index: 2;
  }

  .btn {
    width: 8em;
    font-size: 13px;
    padding-top: 0.5em;
  }

  .logobody {
      display: none;
  }

  a img {
    display: none;
  }

  h1 {
    font-size: 30px;
  }

  h3 {
    font-size: 18px;
  }

  .pd {
    margin-bottom: 40px;
  }

  .mg {
    margin-bottom: 30px;
  }
}

@media only screen and (min-width: 1200px) {
  .hire-body {
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
}
</style>
